import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyprofileRoutingModule } from '../../myprofile/myprofile-routing.module';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReferFriendsComponent } from '../referfriends-link-generation/referfriends.component';
import { ReferFriendsRoutingModule } from './referfriends-routing.module';
import { MatSelectModule, MatTableModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule } from '@angular/material';
import { ReferFriendsListComponent } from './referfriends-list.component';
import { ReferFriendsBannerComponent } from '../referfriends-banner-dailog/referfriends-banner-dailog.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ReferFriendsComponent, ReferFriendsListComponent, ReferFriendsBannerComponent],

  imports: [
    NgbModule,
    CommonModule,
    SharedModule,
    MatSelectModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReferFriendsRoutingModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [],
  exports: [RouterModule, ReferFriendsBannerComponent, ReferFriendsListComponent],

})
export class ReferFriendsModule { }
